import { createSlice, PayloadAction } from "@reduxjs/toolkit";

  

  const ContactInformationSlice = createSlice({
    name: "pendingContactInformation",
    initialState: false,
    reducers: {
      setFieldCompleted: (state, action: PayloadAction<boolean>) => {
        return action.payload; 
      },
    },
  });
  
  export const { setFieldCompleted } = ContactInformationSlice.actions;
  export default ContactInformationSlice.reducer;
  